module.exports = __webpack_public_path__ + "img/9137d19.svg";